<template>
  <div class="ref-info">
    <span>{{ stockId }}</span>
    <span>{{ updateDate }}</span>
  </div>
</template>

<script>
import * as moment from 'moment';

export default {
  props: ['stock'],
  computed: {
    stockId() {
      if (this.stock.gstock_id) {
        let formatStockId = this.stock.gstock_id;
        switch (this.stock.ics_type) {
          case 'i':
            formatStockId = `I${formatStockId.padStart(8, '0')}`;
            break;
          case 'c':
            formatStockId = `C${formatStockId.padStart(7, '0')}`;
            break;
          case 's':
            formatStockId = `S${formatStockId.padStart(6, '0')}`;
            break;
          default:
            break;
        }
        return `${this.$t('find.PROPERTY_ID')}: ${formatStockId} \xa0`;
      }
      return '';
    },
    updateDate() {
      if (this.stock.update_date) {
        const formatUpdateDate = moment(this.stock.update_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
        return `${this.$t('find.UPDATE_DATE')}: ${formatUpdateDate}`;
      }
      return '';
    },
  },
};
</script>

<style scoped>
.ref-info {  
  font-size: 0.70rem;
  line-height: 1rem;
  /*
  position: absolute;
  right: 5px;
  top: -1.1rem;
  */
  color: #aaa;
  white-space: nowrap;
}
</style>